module.exports = __webpack_public_path__ + "static/media/icon_add.9d499754.svg";